<template>
    <div class="main-content">
        <list
            :columns="columns"
            :rows="teams"
            :selectOptions="selectOptions"
            @inactivate="inactivateTeam"
            @activate="activateTeam"
            @edit="editTeam"
        >
            <b-button
                @click="addTeam"
                variant="primary"
                class="btn-rounded"
                slot="table-actions"
            >
                Adicionar
            </b-button>
        </list>
    </div>
</template>

<script>
export default {
    components: {
        List: () => import('@/components/List/List'),
    },
    data () {
        return {
            columns: [
                {
                    label: 'Nome',
                    field: 'name',
                },
                {
                    label: 'Nº Usuários',
                    field: 'users.length',
                },
                {
                    label: 'Gestor',
                    field: 'manager.text',
                    html: true,
                },
                {
                    label: 'Ações',
                    field: 'button',
                    html: true,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
            ],
            selectOptions: {
                enabled: false,
            },
        }
    },
    methods: {
        addTeam () {
            this.$store.dispatch('modals/open', 'addEditTeam')
        },
        editTeam (team) {
            this.$store
                .dispatch('modals/setData', {
                    key: 'addEditTeamData',
                    data: team,
                })
                .then(() => this.$store.dispatch('modals/open', 'addEditTeam'))
        },
        inactivateTeam (team) {
            this.$bvModal
                .msgBoxConfirm(
                    `Você realmente deseja inativar a equipe ${team.name}?`,
                    {
                        title: 'Tem certeza?',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'dark',
                        okTitle: 'Sim',
                        cancelTitle: 'Não',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then(confirm => {
                    if (!confirm) return
                    this.$store.dispatch('team/inactivateTeam', team.uid)
                })
                .catch((err) => {
                    console.log('%c%s:%i', 'color: darkgreen', 'TeamsList.vue', 86, err)
                })
        },
        activateTeam (team) {
            this.$bvModal
                .msgBoxConfirm(
                    `Você realmente deseja ativar a equipe ${team.name}?`,
                    {
                        title: 'Tem certeza?',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'dark',
                        okTitle: 'Sim',
                        cancelTitle: 'Não',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then(confirm => {
                    if (!confirm) return
                    this.$store.dispatch('team/activateTeam', team.uid)
                })
                .catch((err) => {
                    console.log('%c%s:%i', 'color: darkgreen', 'TeamsList.vue', 86, err)
                })
        },
        loadTeams () {
            this.$store.dispatch('team/loadTeams')
        },
    },
    computed: {
        teams () {
            return this.$store.getters['team/teams']
        },
    },
    created () {
        this.loadTeams()
    },
}
</script>
